/**
 * LifeAdvice Administration — section shell.
 *
 * Mirrors quill/QuillSection.tsx: its own <Routes> mounted at
 * /dashboard/lifeadvice/*, with the bare path redirecting to the overview.
 * Unlike Quill there is no health-probe provider — the LifeAdvice service has
 * no admin health endpoint, so each page reports its own reachability (the
 * proxy's 502 surfaces as an EmptyState with Retry).
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LifeAdviceOverviewPage from './overview/LifeAdviceOverviewPage';
import WisdomPillarsPage from './pillars/WisdomPillarsPage';
import PromptsPage from './prompts/PromptsPage';
import CuratedLibraryPage from './curated/CuratedLibraryPage';
import MemberEntriesPage from './entries/MemberEntriesPage';
import LifeAdviceAnalyticsPage from './analytics/LifeAdviceAnalyticsPage';

export const LifeAdviceSection: React.FC = () => (
  <Routes>
    <Route path="/" element={<Navigate to="overview" replace />} />
    <Route path="overview" element={<LifeAdviceOverviewPage />} />
    <Route path="pillars" element={<WisdomPillarsPage />} />
    <Route path="prompts" element={<PromptsPage />} />
    <Route path="curated" element={<CuratedLibraryPage />} />
    <Route path="entries" element={<MemberEntriesPage />} />
    <Route path="analytics" element={<LifeAdviceAnalyticsPage />} />
  </Routes>
);

export default LifeAdviceSection;
